"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.voteSignerAccount = exports.getVotes = exports.getPendingWithdrawals = exports.getAccountRegistrationStatus = exports.celoKit = void 0;
var contractkit_1 = require("@celo/contractkit");
var env_1 = require("../../../env");
var cache_1 = require("../../../cache");
var kit;
var celoKit = function () {
    if (!kit)
        kit = (0, contractkit_1.newKit)((0, env_1.getEnv)("API_CELO_NODE"));
    return kit;
};
exports.celoKit = celoKit;
/**
 * Fetch account registered status. To lock any Celo, account needs to be registered first
 */
var getAccountRegistrationStatus = function (address) { return __awaiter(void 0, void 0, void 0, function () {
    var accounts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.celoKit)().contracts.getAccounts()];
            case 1:
                accounts = _a.sent();
                return [4 /*yield*/, accounts.isAccount(address)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getAccountRegistrationStatus = getAccountRegistrationStatus;
/**
 * Fetch pending withdrawals, with an index
 */
var getPendingWithdrawals = function (address) { return __awaiter(void 0, void 0, void 0, function () {
    var lockedGold, pendingWithdrawals, pendingWithdrawalsWithIndexes;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.celoKit)().contracts.getLockedGold()];
            case 1:
                lockedGold = _a.sent();
                return [4 /*yield*/, lockedGold.getPendingWithdrawals(address)];
            case 2:
                pendingWithdrawals = _a.sent();
                pendingWithdrawalsWithIndexes = pendingWithdrawals
                    .map(function (withdrawal, index) { return (__assign(__assign({}, withdrawal), { index: index })); })
                    .sort(function (a, b) { return a.time.minus(b.time).toNumber(); });
                return [2 /*return*/, pendingWithdrawalsWithIndexes];
        }
    });
}); };
exports.getPendingWithdrawals = getPendingWithdrawals;
/**
 * Fetch all votes
 */
var getVotes = function (address) { return __awaiter(void 0, void 0, void 0, function () {
    var election, voter, _a, _b, activates, activatableValidatorGroups, votes;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, (0, exports.celoKit)().contracts.getElection()];
            case 1:
                election = _c.sent();
                _b = (_a = election).getVoter;
                return [4 /*yield*/, (0, exports.voteSignerAccount)(address)];
            case 2: return [4 /*yield*/, _b.apply(_a, [_c.sent()])];
            case 3:
                voter = _c.sent();
                return [4 /*yield*/, getActivateTransactionObjects(address)];
            case 4:
                activates = _c.sent();
                activatableValidatorGroups = activates.map(function (activate) { return activate.txo.arguments[0]; });
                votes = [];
                voter.votes.forEach(function (vote) {
                    var activeVoteRevokable = true;
                    if (vote.pending.gt(0)) {
                        // If there's a pending vote, it has to be revoked first
                        activeVoteRevokable = false;
                        votes.push({
                            validatorGroup: vote.group,
                            amount: vote.pending,
                            // Not all pending votes can be activated, 24h has to pass
                            activatable: activatableValidatorGroups.includes(vote.group),
                            revokable: true,
                            index: 0,
                            type: "pending"
                        });
                    }
                    if (vote.active.gt(0))
                        votes.push({
                            validatorGroup: vote.group,
                            amount: vote.active,
                            activatable: false,
                            revokable: activeVoteRevokable,
                            index: 1,
                            type: "active"
                        });
                });
                return [2 /*return*/, votes];
        }
    });
}); };
exports.getVotes = getVotes;
var getActivateTransactionObjects = function (address) { return __awaiter(void 0, void 0, void 0, function () {
    var election, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, (0, exports.celoKit)().contracts.getElection()];
            case 1:
                election = _c.sent();
                _b = (_a = election).activate;
                return [4 /*yield*/, (0, exports.voteSignerAccount)(address)];
            case 2: return [4 /*yield*/, _b.apply(_a, [_c.sent()])];
            case 3: return [2 /*return*/, _c.sent()];
        }
    });
}); };
/**
 * Fetch and cache address of a vote signer account
 * Cache it for 1h since vote signer is usually the same account as our address
 */
exports.voteSignerAccount = (0, cache_1.makeLRUCache)(function (address) { return __awaiter(void 0, void 0, void 0, function () {
    var accounts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.celoKit)().contracts.getAccounts()];
            case 1:
                accounts = _a.sent();
                return [4 /*yield*/, accounts.voteSignerToAccount(address)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); }, function (address) { return address; }, {
    ttl: 60 * 60 * 1000
});
//# sourceMappingURL=sdk.js.map